module.exports = __webpack_public_path__ + "img/TrazadoT1.0099894a.svg";